import {
  MembershipApi, // eslint-disable-line no-unused-vars
} from '@clients/bff'
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath()

export default class ExtendedMembershipApi extends MembershipApi {
  getMembershipInfo (options?: any) {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getMembershipInfo(optionsParam)
  }
}
